module.exports = __webpack_public_path__ + "static/media/openflow@2x.6586e6b6.png";